<template>
  <div class="acr-title">
    <h1>文章管理</h1>
    <el-button class="acr-title-add-button" type="primary" v-on:click="openAddCurriculumClassList">
      添加文章
    </el-button>
    <!-- 添加文章浮窗 -->
    <AddCurriculumClassDialog ref="AddCurriculumClassDialog"></AddCurriculumClassDialog>
    <!-- 条件搜索 -->
    <div>
      <el-input class="acr-search-input" placeholder="搜索条件为[课程名/课程ID/分类ID/作者ID]" v-model="searchKey"></el-input>
    </div>
  </div>
</template>

<script>

import AddCurriculumClassDialog from "@/views/control/components/curriculum/CurriculumClass/AddCurriculumClassDialog";

export default {
  name: "CurriculumClassTitle",
  components: {
    AddCurriculumClassDialog
  },
  data() {
    return {
      searchKey: '',
    }
  },
  watch: {
    searchKey: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal.length >= 2) {
        this.$parent.getClassData();
      }
      if (newVal.length === 0) {
        this.$parent.getClassData();
      }
    }
  },
  methods: {
    openAddCurriculumClassList() {
      this.$refs.AddCurriculumClassDialog.enterAddClass();
      this.$refs.AddCurriculumClassDialog.imageUrl = '';
      this.$refs.AddCurriculumClassDialog.dialogFormVisible = true;
    },
  },
}
</script>